import { EMessageV2Status, EMessageType, IMessageV2Schema } from '@cian/chats-api';

import { IMessageInChatListSchema } from '../repositories/chats/entities/chat/MessageInChatListSchema';
import { TChatDataInListResponse, TChatDataInListSchema } from '../types/chatList';
import { getOfferPhone } from '../utils/getOfferPhone';

function transformLastMessageV1toV2(message: IMessageInChatListSchema): IMessageV2Schema {
  const { type, bubbles, read, unread, createdMs } = message;

  const status = read || !unread ? EMessageV2Status.ReadByRecipient : EMessageV2Status.DeliveredToServer;

  return {
    ...message,
    bubbles: bubbles as IMessageV2Schema['bubbles'],
    type: type ? (type as unknown as EMessageType) : EMessageType.Text,
    created: createdMs ? new Date(createdMs).toISOString() : '',
    rowVersion: 0,
    rowVersionV2: '0',
    status,
  };
}
export function transformItemListChatV1(chat: TChatDataInListResponse): TChatDataInListSchema {
  const { message, data, ...anotherFields } = chat;

  return {
    ...anotherFields,
    data: data
      ? {
          ...data,
          offer: data.offer
            ? {
                ...data.offer,
                phones: getOfferPhone(data.offer),
              }
            : undefined,
        }
      : undefined,
    lastMessage: transformLastMessageV1toV2(chat.message),
  };
}
